import React from "react";

import Questionnaires from "./Questionnaires";

import TableContainer from "../../../Shared/TableContainer";
import { LIMIT_OPTIONS } from "../../../PharmacyOrderList/constants";
import { useQuestionnaires } from "../hooks/useQuestionnaires";
import { useTablePagination } from "../../../../hooks/useTablePagination";

const QuestionnairesListContainer = () => {
  const { questionnaires, isLoaded, total } = useQuestionnaires();

  const {
    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange
  } = useTablePagination();

  return (
    <TableContainer>
      <Questionnaires
        isLoading={!isLoaded}
        questionnaires={questionnaires}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        rowsPerPageOptions={LIMIT_OPTIONS}
      />
    </TableContainer>
  );
};

export default QuestionnairesListContainer;
